import {ActionTree, GetterTree, Module, MutationTree} from "vuex";
import {RootState} from "@/store/types";
import {Purchase, PurchaseAgreementFilter, PurchaseFilter, PurchaseState} from "@/modules/purchase/types";
import {getPurchase, getPurchases, getPurchasesAgreements} from "@/services/purchases";

export const state: PurchaseState = {
  purchase: {
    id: "",
    item: undefined,
    unit_price: "",
    date: "",
    id_item: "",
    id_supplier: ""
  },
  loaded: false
}

const actions: ActionTree<PurchaseState, RootState> = {
  async GET_PURCHASE(_, id) {
    return await getPurchase(id);
  },
  async GET_PURCHASES(_, payload: PurchaseFilter) {
    return await getPurchases(payload);
  },
  async GET_PURCHASES_TO_DECLARE(_, payload: PurchaseAgreementFilter) {
    return await getPurchasesAgreements(payload);
  }
}

const mutations: MutationTree<PurchaseState> = {
  SET_PURCHASE(state, purchase: Purchase) {
    state.purchase = purchase;
  },
  SET_LOADING_STATUS(state, status: boolean) {
    state.loaded = status;
  },
}

const getters: GetterTree<PurchaseState, RootState> = {
  PURCHASE(state): Purchase {
    const {purchase} = state;
    return {...purchase};
  },
  LOADING_STATUS(state) : boolean {
    const {loaded} = state;
    return loaded;
  },
}

export const purchase: Module<PurchaseState, RootState> = {
  state,
  actions,
  getters,
  mutations
}
